<app-index [title]="title" [information]="text" [error]="errorCause" [status]="errorStatus"></app-index>